import { widget as Widget } from 'src/vendor/charting_library_v28-1-0';
const vendorPath = '../../vendor/charting_library_v28-1-0/'

// import { widget as Widget } from 'src/vendor/charting_library_v24-002';
// const vendorPath = '../../vendor/charting_library_v24-002/'



export { Widget, vendorPath }
